// SPDX-License-Identifier: AGPL-3.0-or-later

import {getProtectedSessionStorage} from '@app/features/platform/state/ProtectedWebStorage';

const KEY = 'daoi:privy-pending-wallet';
interface PendingLogin {
	appId: string;
	endpoint: string;
	userId: string;
	sid: string;
}
export function privyTokenClaim(token: string, claim: 'sid' | 'sub'): string | null {
	try {
		const payload = JSON.parse(atob(token.split('.')[1].replace(/-/gu, '+').replace(/_/gu, '/'))) as Record<
			string,
			unknown
		>;
		return typeof payload[claim] === 'string' && payload[claim].length > 0 ? payload[claim] : null;
	} catch {
		return null;
	}
}
export function readPendingPrivyLogin(): PendingLogin | null {
	try {
		const value = JSON.parse(getProtectedSessionStorage()?.getItem(KEY) ?? 'null') as PendingLogin | null;
		return value &&
			['appId', 'endpoint', 'userId', 'sid'].every((key) => typeof value[key as keyof PendingLogin] === 'string')
			? value
			: null;
	} catch {
		return null;
	}
}
export function savePendingPrivyLogin(value: PendingLogin): void {
	try {
		getProtectedSessionStorage()?.setItem(KEY, JSON.stringify(value));
	} catch {
		/* Resume requires another explicit sign-in when storage is unavailable. */
	}
}
export function clearPendingPrivyLogin(): void {
	try {
		getProtectedSessionStorage()?.removeItem(KEY);
	} catch {
		/* No key material is stored. */
	}
}

export const privySessionId = (token: string): string | null => privyTokenClaim(token, 'sid');
